import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval } from 'rxjs/observable/interval';
import { WsService } from '@app/shared/services/ws.service';

@Injectable()
export class PingService {

  private maxDelay = 10000//move to configuration
  wsSendTime;

  constructor(
    private http: HttpClient,
    private ws: WsService) { }

  startPingging() {
   /* interval(10000).subscribe(() => {
      let startRequest = new Date().getTime();
      this.http.get('ping').subscribe(res => {
        let ping = new Date().getTime() - startRequest;
        console.log('http ping: ', ping);
        if (ping > this.maxDelay)
          this.serverService.getNextServer();
      })
    });

    this.ws.message.subscribe(res => {
      let msg = JSON.parse(res);
      if (msg.header.type === 'pong') {
        let newTime = new Date().getTime();
        let timeout = newTime - this.ws.wsSendTime;
        console.log('ws delay: ', timeout);
        if (timeout > this.maxDelay)
          this.serverService.getNextServer();
        //add ws reconnect to another server
      }
    })*/
  }



}



// WEBPACK FOOTER //
// ./src/app/shared/services/ping.service.ts